import React from 'react';
import Joi from 'joi-browser';
import * as _ from 'lodash';
import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { validationByJoi } from '../utilities/commonValidation';

import { ConstructionPlacementPlaceService } from '../services/ConstructionPlacementPlace';
import { FieldService } from '../services/Fields';

import { ConstructionPlacementPlaceContents } from '../components/tables/ConstructionPlacementPlace';
import { Delete } from './modals/Commons';
import dialogLoader from '../utilities/dialogLoader';

import urlParamManger from '../utilities/urlParamManager';
import EventManager, { EventType } from '../utilities/EventManager';
import { isPartnerCompanyRoleId } from '../utilities/roleUtility';
import PrimeContractorToggle from '../components/toggle/PrimeContractorToggle';

import * as pages from '../components/pageComponents';
import { TouchDeviceInvisible } from '../components/TouchDeviceInvisible';
import { deleteControlCode } from '../utilities/stringUtil';
import { MasterPageHeader } from '../components/PageHeader';

/**
 * 現場配置計画 - 場所一覧
 *
 * @export
 * @class ConstructionPlacementPlace
 * @extends {React.Component}
 */
export default class ConstructionPlacementPlace extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      roleId: parseInt(localStorage.getItem('role_id'), 10),
      companyBranchId: null,
      parentPlaces: [],
      constructionPlacementPlaces: [],
      canDrop: false, // ドラッグアンドドロップの状態
      dragSort: [], // ドラッグアンドドロップの並び順の仮置き場
      isSettingId: null,
      formValues: {},
      errors: {},
      isLoading: true, // ロード中フラグ
      isRegisterWaiting: false, // 連打防止用
    };
    this.defaultValues = {
      id: null,
      name: '',
      parent_id: 0,
      scale: 100,
      level: 0,
      disabled: 0,
      order: 1,
    };

    this.events = {
      table: {},
      form: {
        editLayout: this.editLayout.bind(this),
        setFormValues: this.setFormValues.bind(this),
        clearFormValues: this.clearFormValues.bind(this),
        set: this.setFlatData.bind(this),
        setDropdown: this.setDropdown.bind(this),
        submit: this.eventSubmit.bind(this),
        validate: this.validate.bind(this),
      },
      modal: {
        deleteModal: this.deleteModal.bind(this),
        delete: this.deleteConstructionPlacementPlace.bind(this),
      },
      // ドラッグアンドドロップ用メソッド
      dnd: {
        onHover: this.onHover.bind(this),
        onBeginDrag: this.onBeginDrag.bind(this),
        onDropped: this.onDropped.bind(this),
        draggable: this.draggable.bind(this),
        orderSubmit: this.eventOrderSubmit.bind(this),
      },
    };

    this.schema = Joi.object().keys({
      id: Joi.allow(),
      name: Joi.string()
        .max(64)
        .required(),
      parent_id: Joi.number().allow(null),
      scale: Joi.number().required(),
      level: Joi.number().required(),
      disabled: Joi.number().required(),
      order: Joi.number().allow(),
    });
  }

  componentDidMount() {
    this.constructionPlacementPlaceList();
  }

  constructionPlacementPlaceList() {
    const fieldId = this.state.fieldId;
    FieldService.info(fieldId).then(fieldResp => {
      if (fieldResp.result) {
        const companyBranchId =
          fieldResp.data.entities.field.company.company_branch_id;
        this.setState({
          companyBranchId,
        });
        const param = {
          field_id: fieldId,
          company_branch_id: companyBranchId,
        };
        ConstructionPlacementPlaceService.placeList(param).then(resp => {
          if (resp.result) {
            const parentPlaces = _.filter(
              resp.data.entities.construction_placement_places,
              place => {
                return !place.parent_id;
              }
            );
            this.setState({
              constructionPlacementPlaces: this.sortPlaces(
                resp.data.entities.construction_placement_places
              ),
              parentPlaces,
              isLoading: false,
            });
          }
        });
      }
    });
  }

  sortPlaces = places => {
    const parentPlaces = _.filter(places, place => {
      return !place.parent_id;
    });
    const sortPlaces = [];
    _.each(parentPlaces, parentPlace => {
      let children = [];
      _.each(places, place => {
        if (parentPlace.id === place.parent_id) {
          parentPlace.hasChildren = true;
          children.push(place);
        }
      });
      sortPlaces.push(parentPlace);
      sortPlaces.push(...children);
    });
    return sortPlaces;
  };

  editLayout = id => {
    urlParamManger.setPage(`Layout:${id}`, this.props.vw);
    EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    this.props.loadPage(pages.Layout, ['Layout', id]);
    urlParamManger.publish();
  };

  setFormValues = value => {
    const formValues = {};
    _.each(Object.keys(this.defaultValues), key => {
      formValues[key] =
        value[key] !== null ? value[key] : this.defaultValues[key];
    });
    this.setState({
      isSettingId: value.id ? value.id : 0,
      formValues,
      errors: {},
    });
  };

  clearFormValues = () => {
    this.setState({
      isSettingId: null,
      formValues: this.defaultValues,
      errors: {},
    });
  };

  setFlatData = e => {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues[e.target.name] = deleteControlCode(e.target.value);
    this.setState({ formValues });
  };

  setDropdown(name, value) {
    let formValues = this.state.formValues;
    formValues[name] = value;
    this.setState({
      formValues,
    });
  }

  /* eslint-disable no-unused-vars */

  /**
   * ホバー
   */
  onHover(props, monitor, component) {}

  /**
   * ドラッグ開始
   */
  onBeginDrag(props, monitor, component) {
    let dragSort = _.cloneDeep(this.state.dragSort);
    dragSort[0] = props.index;
    this.setState({ dragSort });
  }

  /**
   * ドロップダウン
   */
  onDropped(dragProps, dropProps, monitor, dropComponent) {
    let dragSort = _.cloneDeep(this.state.dragSort);
    dragSort[1] = dropProps.index;
    this.setState({ dragSort });
    this.sortList(...this.state.dragSort);
  }
  /* eslint-enable no-unused-vars */

  /**
   * ドラッグ開始、終了
   */
  draggable(bool) {
    this.setState({ canDrag: bool });
  }

  /**
   * @description 並び順を変更する
   */
  sortList(dragIndex, to_index) {
    const lists = _.cloneDeep(this.state.constructionPlacementPlaces);
    const formItem = lists[dragIndex];
    if (to_index < dragIndex) {
      lists.splice(to_index, 0, formItem);
      lists.splice(dragIndex + 1, 1);
    } else {
      lists.splice(to_index + 1, 0, formItem);
      lists.splice(dragIndex, 1);
    }
    this.setState({ constructionPlacementPlaces: this.sortPlaces(lists) });
  }

  // バリデーション
  validate(e) {
    const params = this.state.formValues;
    const result = validationByJoi(this.schema, params);
    const errors = this.state.errors;
    // 単数or複数判定
    if (e) {
      if (result.messages[e.target.name]) {
        errors[e.target.name] = result.messages[e.target.name];
      } else if (errors[e.target.name]) {
        delete errors[e.target.name];
      }
      this.setState({ errors });
    }
    return result.messages;
  }

  eventOrderSubmit = () => {
    const fieldId = this.state.fieldId;
    const companyBranchId = this.state.companyBranchId;
    const items = this.state.constructionPlacementPlaces;
    const params = {
      field_id: fieldId,
      company_branch_id: companyBranchId,
      ids: _.map(items, 'id'),
    };
    ConstructionPlacementPlaceService.updateOrder(params).then(resp => {
      if (resp.result) {
        this.constructionPlacementPlaceList();
      }
    });
  };

  deleteModal(deleteId, callbacks) {
    dialogLoader.show(Delete, {
      state: {
        deleteId,
        callbacks,
      },
    });
  }

  deleteConstructionPlacementPlace = id => {
    ConstructionPlacementPlaceService.del(id).then(resp => {
      if (resp.result) {
        this.constructionPlacementPlaceList();
        this.setState({
          isSettingId: null,
          errors: {},
        });
        dialogLoader.close();
      }
    });
  };

  eventSubmit = () => {
    if (this.state.isRegisterWaiting) {
      return;
    } else {
      this.setState(
        {
          isRegisterWaiting: true,
        },
        () => {
          let validate = this.validate();
          if (validate.name) {
            let errors = this.state.errors;
            errors.name = validate.name;
            this.setState({
              errors,
              isRegisterWaiting: false,
            });
            return;
          }
          const values = this.state.formValues;
          const id = values.id;
          const fieldId = this.state.fieldId;
          const companyBranchId = this.state.companyBranchId;
          const param = {
            field_id: fieldId,
            company_branch_id: companyBranchId,
          };
          if (id) {
            ConstructionPlacementPlaceService.update(id, param, values).then(
              resp => {
                if (resp.result) {
                  this.constructionPlacementPlaceList();
                  this.setState({
                    isSettingId: null,
                    errors: {},
                    isRegisterWaiting: false,
                  });
                }
              }
            );
          } else {
            ConstructionPlacementPlaceService.create(param, values).then(
              resp => {
                if (resp.result) {
                  this.constructionPlacementPlaceList();
                  this.setState({
                    isSettingId: null,
                    errors: {},
                    isRegisterWaiting: false,
                  });
                }
              }
            );
          }
        }
      );
    }
  };

  headerMenu = () => {
    if (this.state.canDrag) {
      return (
        <div className='contructon-layout-list-header__item'>
          <button
            className='btn--effective'
            onClick={() => {
              this.events.dnd.orderSubmit();
              this.events.dnd.draggable(false);
            }}
          >
            保存
          </button>
        </div>
      );
    }
    return (
      <div className='contructon-layout-list-header__item'>
        {!isPartnerCompanyRoleId(this.state.roleId) ? (
          <button
            className={
              this.state.isSettingId !== null ? 'btn btn--disabled' : 'btn'
            }
            onClick={() => this.events.form.setFormValues(this.defaultValues)}
            disabled={this.state.isSettingId !== null}
            style={{
              display: 'inline-block',
            }}
          >
            新規作成
          </button>
        ) : (
          <div /> // 並び順ボタンの位置を守るために空divを追加する
        )}
        {
          <TouchDeviceInvisible>
            <PrimeContractorToggle>
              <button
                className={
                  this.state.isSettingId !== null
                    ? 'btn btn--disabled'
                    : 'btn--sub'
                }
                onClick={() => this.events.dnd.draggable(true)}
                disabled={this.state.isSettingId !== null}
                style={{
                  display: 'inline-block',
                }}
              >
                並び順を変更する
              </button>
            </PrimeContractorToggle>
          </TouchDeviceInvisible>
        }
      </div>
    );
  };

  render() {
    return (
      <div id='main' className='main'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 現場配置計画・場所一覧</title>
        </Helmet>
        <MasterPageHeader title={'現場配置計画 - 場所一覧'} disableHelpMenu />
        <div className='main__body'>
          <div className='contructon-layout-list'>
            <div className='contructon-layout-list__header'>
              {this.headerMenu()}
            </div>
            <ConstructionPlacementPlaceContents
              constructionPlacementPlaces={
                this.state.constructionPlacementPlaces
              }
              parentPlaces={this.state.parentPlaces}
              values={this.state.formValues}
              errors={this.state.errors}
              isSettingId={this.state.isSettingId}
              callbacks={this.events}
              canDrag={this.state.canDrag}
              canEdit={!isPartnerCompanyRoleId(this.state.roleId)}
              isLoading={this.state.isLoading}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ConstructionPlacementPlace.jsx